(() => {
  // CONFIG
  const DURATION = 4800; // ms — tweak to match desired speed
  const SELECTOR_COL = '.services-home .col-container'; // your right column

  const container = document.querySelector(SELECTOR_COL);
  if (!container) return;

  // Collect pairs: each H3 and its immediate following P (if any)
  const headings = Array.from(container.querySelectorAll('h3.body-font'));
  const pairs = headings.map((h3, index) => {
    let p = h3.nextElementSibling;
    // ensure it's the paragraph paired with this heading
    if (!p || p.tagName !== 'P') p = null;
    // inject progress span once
    if (!h3.querySelector('.h3-progress')) {
      const span = document.createElement('span');
      span.className = 'h3-progress';
      h3.appendChild(span);
    }

    // Wrap paragraph in a positioned wrapper for smooth height transitions
    if (p && !p.parentElement.classList.contains('p-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'p-wrapper';
      p.parentNode.insertBefore(wrapper, p);
      wrapper.appendChild(p);
    }

    return { h3, p, wrapper: p ? p.parentElement : null };
  }).filter(({ p }) => p); // only keep complete h3+p pairs

  if (!pairs.length) return;

  // ARIA (optional but recommended)
  container.setAttribute('role', 'tablist');
  container.setAttribute('aria-orientation', 'vertical');
  pairs.forEach(({ h3, p }, i) => {
    const hid = h3.id || `rot-h3-${i}`;
    const pid = p.id || `rot-p-${i}`;
    h3.id = hid; p.id = pid;
    h3.setAttribute('role', 'tab');
    h3.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    h3.tabIndex = i === 0 ? 0 : -1;
    p.setAttribute('role', 'tabpanel');
    p.setAttribute('aria-labelledby', hid);
    if (i !== 0) p.setAttribute('hidden', 'hidden');
  });

  let index = 0;
  let timer = null;
  let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function activate(i, { user=false } = {}) {
    index = (i + pairs.length) % pairs.length;

    pairs.forEach(({ h3, p, wrapper }, idx) => {
      const active = idx === index;

      // toggle classes
      h3.classList.toggle('is-active', active);

      // aria + tab focus mgmt
      h3.setAttribute('aria-selected', String(active));
      h3.tabIndex = active ? 0 : -1;

      if (active) {
        // Set wrapper height to match the active paragraph + extra padding
        p.removeAttribute('hidden');
        requestAnimationFrame(() => {
          const height = p.offsetHeight;
          const extraPadding = 8; // 0.5rem = 8px
          wrapper.style.height = (height + extraPadding) + 'px';
          p.classList.add('is-active');
        });
      } else {
        // Collapse wrapper to 0 height
        wrapper.style.height = '0px';
        // Hide: remove is-active, then add hidden after transition
        p.classList.remove('is-active');
        setTimeout(() => {
          if (!p.classList.contains('is-active')) {
            p.setAttribute('hidden', 'hidden');
          }
        }, 300); // match CSS transition duration
      }

      // reset/restart progress animation by nuking and re-enabling it
      const bar = h3.querySelector('.h3-progress');
      if (bar) {
        bar.style.animation = 'none';
        void bar.offsetWidth; // reflow to restart
        if (active) {
          h3.style.setProperty('--h3-progress-duration', DURATION + 'ms');
          bar.style.animation = ''; // let CSS apply the keyframes
        }
      }
    });

    if (!paused) start();
    if (user) stop(); // momentary pause if user interacted
  }

  function start() {
    stop();
    timer = setTimeout(() => activate(index + 1), DURATION);
  }
  function stop() {
    if (timer) { clearTimeout(timer); timer = null; }
  }

  // Click to jump
  pairs.forEach(({ h3 }, i) => {
    h3.addEventListener('click', () => activate(i, { user: true }));
  });

  // Keyboard (ARIA tabs)
  container.addEventListener('keydown', (e) => {
    const keysNext = ['ArrowRight', 'ArrowDown'];
    const keysPrev = ['ArrowLeft', 'ArrowUp'];
    if (keysNext.includes(e.key)) { e.preventDefault(); activate(index + 1, { user: true }); pairs[index].h3.focus(); }
    if (keysPrev.includes(e.key)) { e.preventDefault(); activate(index - 1, { user: true }); pairs[index].h3.focus(); }
    if (e.key === 'Home') { e.preventDefault(); activate(0, { user: true }); pairs[0].h3.focus(); }
    if (e.key === 'End') { e.preventDefault(); activate(pairs.length - 1, { user: true }); pairs[pairs.length - 1].h3.focus(); }
  });

  // Pause on hover/focus for UX
  ['mouseenter', 'focusin'].forEach(ev => container.addEventListener(ev, stop));
  ['mouseleave', 'focusout'].forEach(ev => container.addEventListener(ev, () => !paused && start()));

  // Respect reduced motion (don't autoplay when switched)
  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  mq.addEventListener?.('change', () => { paused = mq.matches; paused ? stop() : start(); });
  paused = mq.matches;

  // Init - don't activate anything yet
  let hasStarted = false;

  // Start animation when scrolled into view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasStarted) {
        hasStarted = true;
        activate(0); // Activate first item when scrolled into view
      }
    });
  }, {
    threshold: 0.3 // Start when 30% of the container is visible
  });

  observer.observe(container);
})();